export const governanceTour = {
    module: 'governance',
    title: 'Governance Tour',
    title_vi: 'Tour Quản trị',
    description: 'As the Vendor Risk Manager (P-VN-08), maintain the vendor registry, track subprocessor chains, assess cross-border transfer risks, and enforce governance playbooks under PDPL.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Vendor Risk Manager (P-VN-08), maintain the vendor registry, track subprocessor chains, assess cross-border transfer risks, and enforce governance playbooks under PDPL.',
    estimated_duration_seconds: 40,
    steps: [
        {
            step_id: 'open_governance',
            navigate_to: '/admin/governance/vendors',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Vendor Governance Module',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Vendor Governance Module',
            description: 'As the Vendor Risk Manager, you oversee all third-party processor relationships here. PDPL requires written data processing agreements and ongoing oversight of every vendor handling personal data.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Vendor Risk Manager, you oversee all third-party processor relationships here. PDPL requires written data processing agreements and ongoing oversight of every vendor handling personal data.',
            position: 'bottom',
        },
        {
            step_id: 'vendors_list',
            target: '.dm-table',
            title: 'Vendor Registry',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Vendor Registry',
            description: 'All vendors and processors with their risk rating, DPA status, and next review date. Unlike the Program Governance module which tracks internal policies, this focuses specifically on third-party oversight.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All vendors and processors with their risk rating, DPA status, and next review date. Unlike the Program Governance module which tracks internal policies, this focuses specifically on third-party oversight.',
            position: 'bottom',
        },
        {
            step_id: 'add_vendor',
            target: '.dm-header .btn-primary',
            title: 'Add a Vendor',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add a Vendor',
            description: 'Register each vendor or processor before they handle personal data. PDPL prohibits data sharing with unregistered third parties.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register each vendor or processor before they handle personal data. PDPL prohibits data sharing with unregistered third parties.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'fill_vendor_name',
            target: '[data-testid="vendor-name"]',
            wait_for: '[data-testid="vendor-name"]',
            title: 'Enter Vendor Name',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter Vendor Name',
            description: 'Use the exact legal entity name from the data processing agreement for traceability during audits.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Use the exact legal entity name from the data processing agreement for traceability during audits.',
            position: 'bottom',
            action: {
                type: 'fill',
                target: '[data-testid="vendor-name"]',
                value: '[TOUR] CloudSync Analytics',
            },
        },
        {
            step_id: 'fill_vendor_type',
            target: '#vendor-type',
            title: 'Select Vendor Type',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select Vendor Type',
            description: 'Classify the vendor role under PDPL: processor, sub-processor, controller, or joint controller. Each role carries distinct contractual and notification obligations.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Classify the vendor role under PDPL: processor, sub-processor, controller, or joint controller. Each role carries distinct contractual and notification obligations.',
            position: 'bottom',
            action: { type: 'select', target: '#vendor-type', value: 'processor' },
        },
        {
            step_id: 'fill_vendor_country',
            target: '#vendor-country',
            title: 'Enter Country',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Enter Country',
            description: 'Vendors outside Vietnam trigger Decree 13 cross-border transfer requirements and may need transfer impact assessments.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Vendors outside Vietnam trigger Decree 13 cross-border transfer requirements and may need transfer impact assessments.',
            position: 'bottom',
            action: { type: 'fill', target: '#vendor-country', value: 'Germany' },
        },
        {
            step_id: 'fill_dpa_status',
            target: '#vendor-dpa-status',
            title: 'Set DPA Status',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set DPA Status',
            description: 'PDPL mandates a written data processing agreement before any personal data sharing. Track whether the DPA is pending, signed, or expired.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: PDPL mandates a written data processing agreement before any personal data sharing. Track whether the DPA is pending, signed, or expired.',
            position: 'bottom',
            action: { type: 'select', target: '#vendor-dpa-status', value: 'signed' },
        },
        {
            step_id: 'fill_onboarding_status',
            target: '#vendor-onboarding-status',
            title: 'Set Onboarding Status',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set Onboarding Status',
            description: 'Track the vendor onboarding lifecycle. Suspended vendors must have data access revoked; offboarded vendors require evidence of data return or destruction under PDPL.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Track the vendor onboarding lifecycle. Suspended vendors must have data access revoked; offboarded vendors require evidence of data return or destruction under PDPL.',
            position: 'bottom',
            action: { type: 'select', target: '#vendor-onboarding-status', value: 'active' },
        },
        {
            step_id: 'risk_score',
            target: '[data-testid="risk-score"]',
            title: 'Set Risk Score',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Set Risk Score',
            description: 'Assess vendor risk based on data sensitivity, jurisdiction, and security maturity. High-risk vendors require more frequent reviews and enhanced contractual safeguards.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Assess vendor risk based on data sensitivity, jurisdiction, and security maturity. High-risk vendors require more frequent reviews and enhanced contractual safeguards.',
            position: 'bottom',
            action: { type: 'select', target: '[data-testid="risk-score"]', value: 'medium' },
        },
        {
            step_id: 'submit_vendor',
            target: '.dm-form-actions button[type="submit"]',
            title: 'Save the Vendor',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Save the Vendor',
            description: 'Register the vendor in the compliance registry. It will be linked to cross-border assessments, subprocessor chains, and incident response coordination.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register the vendor in the compliance registry. It will be linked to cross-border assessments, subprocessor chains, and incident response coordination.',
            position: 'top',
        },
        {
            step_id: 'subprocessors',
            navigate_to: '/admin/governance/subprocessors',
            target: '[data-testid="subprocessors-section"]',
            wait_for: '[data-testid="subprocessors-section"]',
            title: 'Subprocessors',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Subprocessors',
            description: 'Track the subprocessor chain for each vendor. PDPL requires controllers to know and approve all downstream processors handling personal data.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Track the subprocessor chain for each vendor. PDPL requires controllers to know and approve all downstream processors handling personal data.',
            position: 'bottom',
        },
        {
            step_id: 'add_subprocessor',
            target: '.dm-header .btn-primary',
            title: 'Add a Subprocessor',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add a Subprocessor',
            description: 'Register each subprocessor in the vendor chain. Unregistered subprocessors represent a PDPL compliance gap.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register each subprocessor in the vendor chain. Unregistered subprocessors represent a PDPL compliance gap.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'subprocessor_modal',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Subprocessor Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Subprocessor Form',
            description: 'Link the subprocessor to its parent vendor, specify processed data categories, and document the legal basis. This chain of accountability is required for PDPL third-party oversight.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Link the subprocessor to its parent vendor, specify processed data categories, and document the legal basis. This chain of accountability is required for PDPL third-party oversight.',
            position: 'bottom',
        },
        {
            step_id: 'cross_border',
            navigate_to: '/admin/governance/cross-border',
            target: '[data-testid="cross-border-transfers"]',
            wait_for: '[data-testid="cross-border-transfers"]',
            title: 'Cross-Border Transfers',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Cross-Border Transfers',
            description: 'Document all international data transfers with their Decree 13 safeguards. Each transfer outside Vietnam must have an approved legal mechanism and transfer impact assessment.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Document all international data transfers with their Decree 13 safeguards. Each transfer outside Vietnam must have an approved legal mechanism and transfer impact assessment.',
            position: 'bottom',
        },
        {
            step_id: 'playbooks',
            navigate_to: '/admin/governance/playbooks',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Governance Playbooks',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Governance Playbooks',
            description: 'Playbooks standardize vendor onboarding, periodic reviews, and incident coordination procedures. These ensure repeatable compliance processes across your third-party ecosystem.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Playbooks standardize vendor onboarding, periodic reviews, and incident coordination procedures. These ensure repeatable compliance processes across your third-party ecosystem.',
            position: 'bottom',
        },
        {
            step_id: 'playbooks_list',
            target: '.dm-table',
            title: 'Browse Playbooks',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Browse Playbooks',
            description: 'Each playbook defines step-by-step procedures with assigned roles and SLA targets. As the Vendor Risk Manager, you activate these during vendor lifecycle events.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each playbook defines step-by-step procedures with assigned roles and SLA targets. As the Vendor Risk Manager, you activate these during vendor lifecycle events.',
            position: 'bottom',
        },
        {
            step_id: 'add_playbook',
            target: '.dm-header .btn-primary',
            title: 'Create a Playbook',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Playbook',
            description: 'Define a new governance playbook. Common playbooks include vendor DPA renewal, annual risk reassessment, and data breach vendor coordination.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define a new governance playbook. Common playbooks include vendor DPA renewal, annual risk reassessment, and data breach vendor coordination.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 100,
        },
        {
            step_id: 'playbook_modal',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Playbook Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Playbook Form',
            description: 'Define the playbook name, category, and steps with responsible roles and SLA targets. Completed playbook executions produce audit-grade evidence of your governance process.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define the playbook name, category, and steps with responsible roles and SLA targets. Completed playbook executions produce audit-grade evidence of your governance process.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-form-actions .btn-secondary' },
            duration_ms: 400,
        },
        {
            step_id: 'governance_complete',
            target: '.dm-page',
            title: 'Governance Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Governance Tour Complete',
            description: 'You can now manage the full vendor lifecycle under PDPL: registration, DPA tracking, subprocessor chains, cross-border transfers, and repeatable governance playbooks with audit-grade evidence.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now manage the full vendor lifecycle under PDPL: registration, DPA tracking, subprocessor chains, cross-border transfers, and repeatable governance playbooks with audit-grade evidence.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=governance.js.map